import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http'
import { IconDefinition } from '@ant-design/icons-angular'
import * as AllIcons from '@ant-design/icons-angular/icons'
import { es_ES as localeZorro, NZ_I18N, NZ_ICONS } from 'ng-zorro-antd'
import { NgProgressModule } from '@ngx-progressbar/core'
import { NgProgressRouterModule } from '@ngx-progressbar/router'
import { NgProgressHttpModule } from '@ngx-progressbar/http'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { SharedModule } from '@shared/shared.module';
import { StoreModule } from '@ngrx/store'
import { StoreRouterConnectingModule } from '@ngrx/router-store'
import { metaReducers, reducers } from './store/reducers'
/**
 * Locale Registration
 */
import { registerLocaleData } from '@angular/common'
import { default as localeEs } from '@angular/common/locales/es'
import { CoreModule } from './core/core.module'
import { ErrorConsoleInterceptor } from './core/interceptors/ErrorConsoleInterceptor'
import { TokenInterceptor } from './core/interceptors/TokenInterceptor'
import { TokenRefreshInterceptor } from './core/interceptors/TokenRefreshInterceptor'
import { environment } from '../environments/environment'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { EffectsModule } from '@ngrx/effects'

import { MsalModule, MsalInterceptor } from '@azure/msal-angular';

const LOCALE_PROVIDERS = [
  { provide: LOCALE_ID, useValue: 'es' },
  { provide: NZ_I18N, useValue: localeZorro },
]
registerLocaleData(localeEs, 'es')

/**
 * AntDesign Icons
 */
const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition
}
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key])
const OAUTH_365 = environment.oauth_setting

export const protectedResourceMap: [string, string[]][] = [[OAUTH_365.todolist, [`api://${OAUTH_365.appId}/${OAUTH_365.scope_name}`]], [OAUTH_365.graph_me, [OAUTH_365.options_365]]];

@NgModule({
  declarations: [AppComponent],
  imports: [
    MsalModule.forRoot({
      clientID: OAUTH_365.appId,
      authority: OAUTH_365.authority,
      consentScopes: ['user.read', `api://${OAUTH_365.appId}`],
      cacheLocation: 'localStorage',
      protectedResourceMap: protectedResourceMap,
      navigateToLoginRequestUrl: false,
      redirectUri: OAUTH_365.redirect_uri,
    }),
    CoreModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,

    /**
     * NgRx Store
     */
    StoreModule.forRoot(reducers, { metaReducers }),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument({ maxAge: 25 }) : [],
    /**
     * Nprogress Modules
     */
    NgProgressModule.withConfig({
      thick: true,
      spinner: false,
      color: '#0190fe',
    }),
    NgProgressRouterModule,
    NgProgressHttpModule,

    /**
     * Routing Module
     */
    AppRoutingModule,
    SharedModule
  ],
  providers: [
    ...LOCALE_PROVIDERS,
    { provide: NZ_ICONS, useValue: icons },
    { provide: ErrorHandler, useClass: ErrorConsoleInterceptor },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenRefreshInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
